/**
 * @file 账户信息
 * @author fuqiang15
 */

import FormModel from '@baidu/ve-ria/views/FormModel';
import {map} from 'lodash';

export default class LotteryServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    /**
     * @override
     */
    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {
            text: ''
        }
    ];

    serviceDetail = null;
    serviceTypeMap = this.getConstantMap('APP_SERVICE_TYPE');
    pageTypeMap = this.getConstantMap('PAGE_TYPE');

    formerPageType = null;

    init() {
        super.init();

        this.setCrumbData();
        this.id = this.getRouteParams().serviceId;
        this.formerPageType = this.getRouteQuery().formerPageType;
        this.detailRequester = this.api.appServiceLotteryDetail;
        this.publishRequester = this.api.appServiceLotteryPublish;
        this.isAdmin = !!this.getRouteMeta().isAdmin;
    }

    adaptData(data) {
        this.serviceDetail = data;
        let isDraft = data.serviceStatus === 'DRAFT';

        data.awards = map(data.awards, item => {
            item.payload = {
                id: data.serviceId,
                awardId: item.id,
                environment: isDraft ? 'sandbox' : 'formal'
            };
            return item;
        });
    }

    requestPublish() {
        return this.publishRequester({id: this.serviceDetail.serviceId});
    }

    setCrumbData() {
        let actionText = this.pageTypeMap[this.pageType] || '编辑';
        this.crumbData[1].text = `${actionText}领券服务`;
    }
}
